module.exports = __webpack_public_path__ + "img/0-45.b0d526ea.jpg";